import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'pickerData',
        label: 'ksBridge不可用时选项数据',
        type: 'picker-array',
    },
    ...requiredProps,
    {
        key: 'requiredCity',
        label: '是否必选城市',
        type: 'boolean',
    },
    {
        key: 'errRequiredCity',
        label: '必选城市提示文案',
        type: 'string',
    },
    ...validatorProps,
];

export const init = () => ({
    ...ablePropsInit,
    placeholder: '请选择',
    pickerData: [],
    ...requiredPropsInit,
    requiredCity: false,
    errRequiredCity: '',
    ...validatorPropsInit,
});

export const name = '省市选择器';

export const component = 'mobile-general-form-city-picker';

export const events = [
    'no-ks-bridge',
    'user-input',
    'change',
    ...baseEvents,
];

